// Angular
import { Component, OnInit } from "@angular/core";
// Models

import { Tournament } from "./../../models/tournament";
// Services
import { AngularFireDatabase } from "angularfire2/database";
import { FormGroup, FormControl, Validators } from "@angular/forms";

import { ApiService } from "./../../services/api";
import * as lodash from "lodash";
import { OAuthService } from "./../../services/o-auth";
import { Club } from "./../../models/club";
import { ActivatedRoute } from "@angular/router";
import { async } from "@angular/core/testing";

@Component({
  templateUrl: "./club.scorecards.component.html",
})
export class ClubScorecardsComponent implements OnInit {
  public scorecardCountList: Array<any>;
  public userScorecardCountList: Array<any>;
  public scorecardCount = 0;
  public imageLoader: boolean = true;
  public filterargs: any;
  public clubId: any;
  public club: any;
  constructor(
    private fireDatabase: AngularFireDatabase,
    private apiService: ApiService,
    private oAuthService: OAuthService,
    private route: ActivatedRoute
  ) {
    this.scorecardCountList = [];
    this.userScorecardCountList = [];

    this.filterargs = {
      item: {
        clubName: "",
      },
    };
  }

  ngOnInit() {
    this.userScorecardCountList.push({
      item: { fullName: "Manual Player", username: "manual" },
      count: 0,
    });

    this.clubId = this.route.snapshot.paramMap.get("id");
    this.apiService.object("users/" + this.clubId).then((res) => {
      this.club = res;
    });

    return Promise.all([this.getTournament(), this.getScorecard()]).then(
      (res) => {
        for (let k = 0; k < this.scorecardCountList.length; k++) {
          const element = this.scorecardCountList[k];
          console.log(element);

          this.apiService.object("users/" + element.item).then((res) => {
            if (res.fullName) {
              res.id = element.item;
              this.userScorecardCountList.push({
                item: res,
                count: element.count,
              });
            } else {
              ++this.userScorecardCountList[0].count;
            }
          });
        }

        for (let v = 0; v < this.userScorecardCountList.length; v++) {
          const element = this.userScorecardCountList[v];
          console.log(element);

          if (element.count == 0) {
            this.userScorecardCountList.splice(v, 1);
          }
        }
        this.scorecardCount = 0;

        for (let l = 0; l < this.scorecardCountList.length; l++) {
          const element = this.scorecardCountList[l];
          this.scorecardCount = this.scorecardCount + element.count;
        }

        this.imageLoader = false;
      }
    );
  }

  async getTournament() {
    let promise = new Promise((resolve, reject) => {
      this.apiService
        .list(`tournaments`, { orderByChild: "cid", equalTo: this.clubId })
        .then((tour: Array<any>) => {
          var result = tour.filter((tournament) => {
            return tournament.cid === this.clubId;
          });
          lodash.forEach(result, (item1, teamKey) => {
            if (item1.leaderboard) {
              if (item1.teamPlay == 0) {
                lodash.forEach(item1.leaderboard, (team, teamKey) => {
                  lodash.forEach(team, (player, playerUid) => {
                    if (playerUid !== "team") {
                      if (this.scorecardCountList.length) {
                        var i = -1;
                        for (i = 0; i < this.scorecardCountList.length; i++) {
                          var element = this.scorecardCountList[i];
                          if (element.item == playerUid) {
                            break;
                          }
                        }
                        console.log(teamKey);
                        if (i != this.scorecardCountList.length && i > -1) {
                          ++this.scorecardCountList[i].count;
                          // if (item1.clubName) {
                          //   this.scorecardCountList[i].item = item1;
                          // }
                        } else {
                          // this.getUser(playerUid)
                          this.scorecardCountList.push({
                            item: playerUid,
                            count: 1,
                          });
                        }
                      } else {
                        console.log(playerUid);

                        // this.getUser(playerUid);
                        this.scorecardCountList.push({
                          item: playerUid,
                          count: 1,
                        });
                      }
                      ++this.scorecardCount;
                    }
                  });
                });
              }
              if (item1.teamPlay > 0) {
                lodash.forEach(item1.leaderboard, (team, teamKey) => {
                  lodash.forEach(team, (status, teamPlayer) => {
                    if (teamPlayer != "team") {
                      if (this.scorecardCountList.length) {
                        var i = -1;
                        for (i = 0; i < this.scorecardCountList.length; i++) {
                          var element = this.scorecardCountList[i];
                          if (element.item == teamPlayer) {
                            break;
                          }
                        }
                        if (i != this.scorecardCountList.length && i > -1) {
                          ++this.scorecardCountList[i].count;
                          // if (item1.clubName) {
                          //   this.scorecardCountList[i].item = item1;
                          // }
                        } else {
                          this.scorecardCountList.push({
                            item: teamPlayer,
                            count: 1,
                          });
                        }
                      } else {
                        this.scorecardCountList.push({
                          item: teamPlayer,
                          count: 1,
                        });
                      }
                      ++this.scorecardCount;
                    }
                  });
                });
              }
            }
          });
          resolve(1);
        });
    });
    return promise;
  }
  getScorecard() {
    let promise = new Promise((resolve, reject) => {
      this.apiService.list(`/scorecards/`).then((sco: Array<any>) => {
        var result = sco.filter((tournament) => {
          return tournament.cid === this.clubId;
        });
        lodash.forEach(result, (item1, teamKey) => {
          if (item1.leaderboard) {
            lodash.forEach(item1.leaderboard, (team, teamKey) => {
              lodash.forEach(team, (player, playerUid) => {
                if (playerUid !== "team") {
                  if (this.scorecardCountList.length) {
                    var i = -1;
                    for (i = 0; i < this.scorecardCountList.length; i++) {
                      var element = this.scorecardCountList[i];
                      if (element.item == playerUid) {
                        break;
                      }
                    }
                    if (i != this.scorecardCountList.length && i > -1) {
                      ++this.scorecardCountList[i].count;
                    } else {
                      this.scorecardCountList.push({
                        item: playerUid,
                        count: 1,
                      });
                    }
                  } else {
                    this.scorecardCountList.push({ item: playerUid, count: 1 });
                  }
                  console.log(this.scorecardCountList);
                }
              });
            });
          }
        });
        resolve(1);
      });
    });
    return promise;
  }
  getUser(uid) {
    return this.apiService.object("users/" + uid).then((res) => {
      if (res) {
        this.scorecardCountList.push({ item: res, count: 1 });
      }

      return res;
    });
  }
}
